export const ContactNoteLoading = () => {
  return <div data-testid="contact-note-loading">Loading...</div>;
};
